import { render, staticRenderFns } from "./SalesDetailTable.vue?vue&type=template&id=67076e5b&"
import script from "./SalesDetailTable.vue?vue&type=script&lang=js&"
export * from "./SalesDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports